import React from "react";
import StoreOrders from "../../components/Store/StoreOrders";

export default function StoreOrdersPage() {
  return <StoreOrders />;
}